"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleDisposeType = exports.vehicleRedeemType = exports.vehicleAgreement = exports.vehicleOnlineStatus = void 0;
const complex_data_1 = require("complex-data");
exports.vehicleOnlineStatus = new complex_data_1.SelectList({
    name: '车辆在线状态',
    list: [
        {
            value: -1,
            label: '未上线'
        },
        {
            value: 0,
            label: '离线'
        },
        {
            value: 1,
            label: '在线'
        }
    ]
});
exports.vehicleAgreement = new complex_data_1.SelectList({
    name: '车辆协议',
    list: [
        {
            value: 'GB17691',
            label: '燃油车'
        },
        {
            value: 'GB32960',
            label: '新能源'
        },
        {
            value: 'GB4NR',
            label: '农装'
        },
    ]
});
exports.vehicleRedeemType = new complex_data_1.SelectList({
    name: '车辆赎回类型',
    list: [
        {
            value: '1',
            label: '赎回转正常',
        },
        {
            value: '2',
            label: '赎回结清',
        }
    ]
});
exports.vehicleDisposeType = new complex_data_1.SelectList({
    name: '车辆处置类型',
    list: [
        {
            value: '1',
            label: '车辆处置',
        },
        {
            value: '2',
            label: '处置再分期',
        },
        {
            value: '3',
            label: '处置转法讼',
        }
    ]
});
